// CUSTOM BUTTON WITH ICONS
import { Button, CircularProgress } from '@mui/material';
import CustomTooltipWithoutRoundBorder from '../../../CustomActionButtonWithTooltip/CustomTooltipWithoutRoundBorder';
const ActionButtonWithIcon = ({ label, labelColor, onClick, icon: Icon, backgroundColor = '#006CB8', hoverColor = '#005F8A', borderColor, iconColor,
    loading = false,

}) => {
    return (

        <CustomTooltipWithoutRoundBorder title={label}>
            <Button
                style={{ margin: 0 }}
                variant="outlined"
                startIcon={
                    loading ? (
                        <CircularProgress size={20} color="inherit" />
                    ) : (
                        Icon && <Icon style={{ color: iconColor }} />
                    )
                }
                onClick={onClick}
                disabled={loading} // disable button during loading
                sx={{
                    // textTransform: 'none',
                    // width: '85px',
                    // height: '45px',
                    // fontWeight: 600,
                    // fontSize: '14px',
                    // lineHeight: '19.6px',
                    // letterSpacing: '2%',
                    backgroundColor: backgroundColor,
                    color: labelColor ? labelColor : '#FFFFFF',
                    borderColor: borderColor ? borderColor : backgroundColor,
                    // padding: '1rem',
                    // width: '100%',
                    borderRadius: 3,
                    padding: '0.5rem',

                    '&:hover': {
                        backgroundColor: hoverColor,
                        borderColor: iconColor,
                    }, "& .MuiButton-startIcon": {
                        marginLeft: "0px",
                        marginRight: "0px", // controls space from start icon to label
                    },
                }}
            >
                {/* {label} */}
            </Button>
        </CustomTooltipWithoutRoundBorder>

        // A NORMAL BUTTON WITHOUT TOOLTIP
        // <Button
        //     variant="outlined"
        //     startIcon={
        //         loading ? (
        //             <CircularProgress size={20} color="inherit" />
        //         ) : (
        //             Icon && <Icon style={{ color: iconColor }} />
        //         )
        //     }
        //     onClick={onClick}
        //     disabled={loading} // disable button during loading
        //     sx={{
        //         textTransform: 'none',
        //         width: '85px',
        //         height: '45px',
        //         fontWeight: 600,
        //         fontSize: '14px',
        //         lineHeight: '19.6px',
        //         letterSpacing: '2%',
        //         backgroundColor: backgroundColor,
        //         color: labelColor ? labelColor : '#FFFFFF',
        //         borderColor: borderColor ? borderColor : backgroundColor,
        //         padding: '1rem',
        //         width: '100%',
        //         borderRadius: 3,
        //         '&:hover': {
        //             backgroundColor: hoverColor,
        //             borderColor: iconColor,
        //         }
        //     }}
        // >
        //     {label}
        // </Button>
    );
};

export default ActionButtonWithIcon;
